import '@sapudex/web-components/dist/AccordionItem.js';
import '@sapudex/web-components/dist/Tag.js';
import '@ui5/webcomponents-icons/dist/discussion-2.js';
import '@ui5/webcomponents-icons/dist/slim-arrow-left.js';
import '@ui5/webcomponents-icons/dist/slim-arrow-right.js';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductDetailsModule} from './details/product-details.module';
import {ConfiguratorModule} from './configurator/configurator.module';
import {CtaFormModule} from './cta-form/cta-form.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConfiguratorModule,
    CtaFormModule,
    ProductDetailsModule,
  ]
})
export class ProductModule {}
